import axios from '@fs/zion-axios'

/**
 * Gets a group's information.
 * @param {string} groupId - The group's ID.
 * @throws 400 - The group id was invalid.
 * @throws 403 - Only un-banished group members can view a group.
 * @throws 404 - Group not found.
 * @throws 410 - Group is tombstoned.
 * @returns {Promise} axios.get promise
 */
export default function getGroup(groupId) {
  return axios.get(`/service/tree/tree-data/groups/${groupId}`).then((res) => res.data)
}
